// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCallLogByIdRequestModel from '../../model/get-call-log-by-id-request-model';
import GetCallLogByIdRequestDTO from '../dto/get-call-log-by-id-request-dto';
import dtoSchema from '../schemas/get-call-log-by-id-request-schema';

export default abstract class GetCallLogByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCallLogByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetCallLogByIdRequestDTO>): GetCallLogByIdRequestModel;
  static toModel(dto: DeepPartial<GetCallLogByIdRequestDTO> | undefined | null): GetCallLogByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCallLogByIdRequestDTO> | undefined | null): GetCallLogByIdRequestModel | undefined {
    return dto ? new GetCallLogByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCallLogByIdRequestModel> | GetCallLogByIdRequestModel): GetCallLogByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetCallLogByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCallLogByIdRequestModel, can not map to GetCallLogByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
